import { bool } from 'prop-types';
import React, { useRef } from 'react';

import HoverDetails from '../../generic/HoverDetails';
import IconLink from '../../generic/IconLink';
import { targetSupplierShape } from '../../prop-types';

function TargetSupplierLink({ model, showIcon, verbose, ...rest }) {
  const linkRef = useRef(null);
  const { id, name, creditorNumber } = model;
  return (
    <>
      <span ref={linkRef}>
        <IconLink
          showIcon={showIcon}
          to={`/target-supplier/${id}/show`}
          {...rest}
        >
          {name}
        </IconLink>
      </span>
      {verbose && <span className="small pl-2">{creditorNumber}</span>}
      <HoverDetails
        size="large"
        linkRef={linkRef}
        title={name}
        fields={{
          Name: name,
          'Creditor Number': creditorNumber,
        }}
      />
    </>
  );
}

TargetSupplierLink.propTypes = {
  model: targetSupplierShape.isRequired,
  showIcon: bool,
  verbose: bool,
};

TargetSupplierLink.defaultProps = {
  showIcon: false,
  verbose: false,
};

export default TargetSupplierLink;
